// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__2UtlM","question":"Question_question__1rdmL","description":"Question_description__1-DSm"};